/**
 * Единственная точка HTTP-слоя, где берётся браузерный транспорт. Весь остальной
 * код ходит через функции этого слоя (`fetchWithRefresh`, `tracedFetch`,
 * `tracedHttpClient`), а обращение к глобали живёт здесь одной строкой: так
 * обработка ошибок и подстановка заголовков остаются в одном месте, а тест
 * подменяет транспорт, подменив глобаль.
 *
 * Привязка берётся в момент вызова, а не при загрузке модуля: тесты подменяют
 * `globalThis.fetch` уже после импорта, и раннее связывание захватило бы
 * настоящий транспорт вместо подмены. Аргументы передаются как есть, без
 * дописывания `undefined`, чтобы вызов доходил до транспорта той же арности,
 * какой его написал вызывающий.
 */
export const browserFetch: typeof fetch = (...request) => {
  const transport = globalThis.fetch.bind(globalThis);
  return transport(...request);
};
